<template>
  <div class="thumb_animation">
    <div class="box">
      <lottie :options="defaultOptions"
              @animCreated="handleAnimation"
              v-if="isShow" />
    </div>

    <button @click="stop">stop</button>
    <button @click="pause">pause</button>
    <button class="btn primary"
            @click="play">play</button>
  </div>
</template>
<script>
import Lottie from '../../components/lottie';
import animationData from '../../assets/lottie-4' // 引入json文件
export default {
  props: ['learning'],
  components: {
    Lottie
  },
  data () {
    return {
      isShow: true,
      thumb_animation: false,
      defaultOptions: {
        animationData: animationData,
        autoplay: true,//是否自动播放
        loop: true//不循环
      },
      animationSpeed: 0.1,
      anim: {}
    }
  },
  methods: {
    handleAnimation (anim) {
      this.anim = anim;
      // setTimeout(() => {
      //   this.isShow = false;
      // }, 3000)
    },
    stop: function () {
      this.anim.stop();
    },
    play: function () {
      this.isShow = true;
      // this.anim.play();
    },
    pause: function () {
      this.anim.pause();
    },
  },
  destroyed () {
    this.anim.destroy()
  }
}
</script>
<style scope>
button {
  display: block;
  color: #f00;
  font-size: 0.16rem;
  text-align: center;
}
</style>